var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Comfortable & Cozy Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Comfortable & Cozy Line",
      "file": "comfortable"
    }
  }, [_vm._v(" Single, Towel Terry, Fleece, Texture etc, Variety structure with brush effect. From home to outside, Our soft knit line gives you comfort & cozy feeling you need. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }